import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _ = function _(t) {
    return t;
  },
  _t;
var _excluded = ["start", "end", "base"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { cssForBreakpointsConfig } from "../../../util/mediaqueries";
export var getGridPositionsFor = function getGridPositionsFor(positionType, _ref) {
  var start = _ref.start,
    end = _ref.end,
    base = _ref.base,
    breakpointConfigs = _objectWithoutProperties(_ref, _excluded);
  return cssForBreakpointsConfig(_objectSpread({
    base: {
      start: start || (base === null || base === void 0 ? void 0 : base.start),
      end: end || (base === null || base === void 0 ? void 0 : base.end)
    }
  }, breakpointConfigs))(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), 0)), function (_ref2) {
    var start = _ref2.start,
      end = _ref2.end;
    return "\n    ".concat(start && "grid-".concat(positionType, "-start: ").concat(start, ";"), "\n    ").concat(end && "grid-".concat(positionType, "-end: ").concat(end, ";"), "\n  ");
  });
};
export var gridPosition = function gridPosition() {
  var _start = 0;
  var _end = 0;
  var create = function create() {
    return {
      start: _start,
      end: _end
    };
  };
  var gridPositionHelperApi = {
    start: function start(newStart) {
      _start = newStart;
      return gridPositionHelperApi;
    },
    end: function end(newEnd) {
      _end = newEnd;
      return gridPositionHelperApi;
    },
    fill: function fill() {
      if (!_start && !_end) {
        _start = 1;
        _end = -1;
      } else if (_start) {
        _end = -1;
      } else if (_end) {
        _start = 1;
      }
      return create();
    },
    size: function size(newSize) {
      if (!_start && !_end) {
        throw Error('gridPosition size() should be called after start() or end()');
      }
      if (_start) {
        _end = _start > 0 ? _start + newSize : _start - newSize;
      } else if (_end) {
        _start = _end - newSize;
      }
      return create();
    },
    pad: function pad(unit) {
      _start = unit;
      _end = unit * -1;
      return create();
    }
  };
  return gridPositionHelperApi;
};